import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import style from "./MenuBar.module.css";
import clsx from "classnames";
import { useTranslation } from "react-i18next";
import { requester, medusaRequester } from "App";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import { BrowserDetectContext } from "providers/BrowserEventProvider";

function MenuBar(props) {
    const { t } = useTranslation();
    const [categories, setCategories] = useState();
    const { isMobile } = useContext(BrowserDetectContext);
    
    const { filterClick } = props;


    useEffect(() => {
        let data = "";
        medusaRequester.getAllCategories(data, (result) => {
            const categoryOrder = ["입호흡 액상", "모드 액상", "기계", "코일및기타용품"];

            const sortedCategories = result.product_categories.sort((a, b) => {
                return categoryOrder.indexOf(a.name) - categoryOrder.indexOf(b.name);
            });

            setCategories(sortedCategories);
        });
    }, []);

    const Tab = ({ text, url }) => {
        return (
            <Center>
                <NavLink to={url} className={({ isActive }) => clsx(style.menu, { [style.active]: isActive }, { [style.mobile]: isMobile })} >
                    <div onClick={() => filterClick(0)} style={{ width: "100%", height: "100%", padding: `${isMobile ? "0px" : "0px 50px"}`, fontSize: "18px" }}>
                        {text}
                    </div>

                </NavLink >
            </Center>
        );
    }
    const MobileTab = ({ text, url }) => (
        <NavLink
            to={url}
            className={({ isActive }) =>
                clsx(style.menu, { [style.active]: isActive })
            }
        >
            <div className={style.tabWrapper}>
                <P nowrap>{text}</P>
            </div>
        </NavLink>
    );

    return (
        <div className={clsx(style.container, { [style.mobile]: isMobile })}>
            {
                isMobile
                    ?
                    <div className={clsx(style.container, { [style.mobile]: isMobile })}>
                        <div className={style.scrollContainer}>
                            <MobileTab text={t("전체")} url={"/productList/category/all"} />
                            <MobileTab text={t("이벤트")} url={"/productList/category/event"} />
                            {categories &&
                                categories.map((category, index) => (
                                    <MobileTab
                                        key={index}
                                        text={category.name}
                                        url={`/productList/category/${category.id}`}
                                    />
                                ))}
                        </div>
                    </div>
                    :
                    <Container minWidth={!isMobile && 1200} backgroundColor={"white"}>
                        <HorizontalFlex padding={"10px"}>
                            {
                                !isMobile &&
                                <FlexChild></FlexChild>
                            }
                            <FlexChild width={"initial"}>
                                <Tab text={t("allProducts")} url={"/productList/category/all"} />
                            </FlexChild>
                            <FlexChild width={"initial"}>
                                <Tab text={t("이벤트")} url={"/productList/category/event"} />
                            </FlexChild>
                            {
                                categories && categories.map((category, index) =>
                                    <FlexChild key={index} width={"initial"}>
                                        <Tab text={category.name} url={`/productList/category/${category.id}`} />
                                    </FlexChild>
                                )
                            }
                            {
                                !isMobile &&
                                <FlexChild></FlexChild>
                            }
                        </HorizontalFlex>
                    </Container>
            }

        </div>
    );
}

export default MenuBar;